import { SVGProps } from "react";

export const VerificationFailIllustration = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    fill="none"
    {...props}
  >
    <circle cx={44} cy={46} r={32} fill="#DEDFE0" opacity={0.2} />
    <rect width={68} height={20} x={10} y={36} fill="#3E8D96" rx={2} />
    <mask
      id="a"
      width={12}
      height={12}
      x={14}
      y={40}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M14 40h12v12H14V40Z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#F7F8F8"
        d="M20 51.001a4.869 4.869 0 0 1-1.95-.393 5.049 5.049 0 0 1-1.587-1.07c-.45-.45-.806-.978-1.069-1.587a4.869 4.869 0 0 1-.394-1.95c0-.691.132-1.341.394-1.95a5.05 5.05 0 0 1 1.069-1.587c.45-.45.979-.806 1.587-1.069a4.869 4.869 0 0 1 1.95-.394 4.87 4.87 0 0 1 1.95.394 5.05 5.05 0 0 1 1.588 1.069c.45.45.806.98 1.069 1.587a4.87 4.87 0 0 1 .393 1.95c0 .692-.13 1.342-.393 1.95a5.048 5.048 0 0 1-1.07 1.588c-.45.45-.978.806-1.587 1.069A4.87 4.87 0 0 1 20 51Z"
      />
    </g>
    <rect
      width={22}
      height={3}
      x={28}
      y={42}
      fill="#F7F8F8"
      opacity={0.9}
      rx={1}
    />
    <rect
      width={46}
      height={3}
      x={28}
      y={47}
      fill="#F7F8F8"
      opacity={0.6}
      rx={1}
    />
    <path
      fill="#AACFD3"
      d="M25.043 13.143c.288-.945 1.626-.945 1.914 0l1.688 5.547a1 1 0 0 0 .665.665l5.547 1.688c.945.288.945 1.626 0 1.914l-5.547 1.688a1 1 0 0 0-.665.665l-1.688 5.547c-.288.945-1.626.945-1.914 0l-1.688-5.547a1 1 0 0 0-.665-.665l-5.547-1.688c-.945-.288-.945-1.626 0-1.914l5.547-1.688a1 1 0 0 0 .665-.665l1.688-5.547ZM61.043 65.143c.288-.945 1.626-.945 1.914 0l.755 2.48a1 1 0 0 0 .665.665l2.48.755c.945.288.945 1.626 0 1.914l-2.48.755a1 1 0 0 0-.665.665l-.755 2.48c-.288.945-1.626.945-1.914 0l-.755-2.48a1 1 0 0 0-.665-.665l-2.48-.755c-.945-.288-.945-1.626 0-1.914l2.48-.755a1 1 0 0 0 .666-.665l.754-2.48Z"
    />
    <mask
      id="b"
      width={20}
      height={20}
      x={59}
      y={11}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M59 11h20v20H59z" />
    </mask>
    <g mask="url(#b)">
      <circle cx={69} cy={21} r={6.667} fill="#fff" />
      <path
        fill="#E44968"
        d="M69.021 21.75a1.1 1.1 0 0 0 .802-.344 1.1 1.1 0 0 0 .344-.802v-2.792c0-.305-.115-.569-.344-.791a1.117 1.117 0 0 0-.802-.333c-.306 0-.573.114-.802.343a1.1 1.1 0 0 0-.344.802v2.792c0 .305.115.57.344.792.229.222.496.333.802.333ZM69 25.521c.292 0 .545-.1.76-.302a1.02 1.02 0 0 0 .323-.781c0-.292-.108-.546-.323-.761a1.038 1.038 0 0 0-.76-.323c-.292 0-.545.108-.76.323a1.041 1.041 0 0 0-.323.761c0 .32.108.58.323.781.215.201.468.302.76.302ZM69 30c-1.25 0-2.42-.236-3.51-.708a9.136 9.136 0 0 1-2.855-1.927 9.136 9.136 0 0 1-1.927-2.855A8.737 8.737 0 0 1 60 21c0-1.25.236-2.424.708-3.521a9.093 9.093 0 0 1 1.927-2.864 8.973 8.973 0 0 1 2.855-1.917A8.846 8.846 0 0 1 69 12c1.25 0 2.424.233 3.521.698a8.932 8.932 0 0 1 2.864 1.917 8.932 8.932 0 0 1 1.917 2.864A8.925 8.925 0 0 1 78 21c0 1.25-.233 2.42-.698 3.51a8.973 8.973 0 0 1-1.917 2.855 9.093 9.093 0 0 1-2.864 1.927A8.815 8.815 0 0 1 69 30Z"
      />
    </g>
  </svg>
);
